import { getText } from "@/utils/util";
import { useTranslation } from "react-i18next";

export function HistoryData() {
  const { t: translate } = useTranslation();

    return (
      <div
        data-v-4389a7cf=""
        className="introduce mx-4 mb-5 mt-8 flex flex-wrap rounded-2xl px-4 py-2 md:mx-auto md:my-[60px] md:h-auto md:w-full md:max-w-[1200px] md:flex-nowrap md:items-center md:p-0 md:px-[60px] lg:h-[100px] lg:px-[100px] xl:my-[80px]"
      >
        <div data-v-4389a7cf="" className="items">
          <span data-v-4389a7cf="">150+</span>
          <p data-v-4389a7cf="">{translate(getText("國家使用者"))}</p>
        </div>
        <div data-v-4389a7cf="" className="dividing-line"></div>
        <div data-v-4389a7cf="" className="items">
          <span data-v-4389a7cf="">900{translate(getText("萬"))}</span>
          <p data-v-4389a7cf="">{translate(getText("全球投資者"))}</p>
        </div>
        <div data-v-4389a7cf="" className="dividing-line"></div>
        <div data-v-4389a7cf="" className="items">
          <span data-v-4389a7cf="">300+</span>
          <p data-v-4389a7cf="">{translate(getText("專案幣種"))}</p>
        </div>
        <div data-v-4389a7cf="" className="dividing-line"></div>
        <div data-v-4389a7cf="" className="items">
          <span data-v-4389a7cf="">$2{translate(getText("億"))}</span>
          <p data-v-4389a7cf="">{translate(getText("24H 成交額"))}</p>
        </div>
      </div>
    );
}